 <template>
    <diV style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="dailyReportForm" :model="dailyReportForm" 
        size="mini" label-width="120px">
            <el-form-item label="创建日期" prop="createDate"> 
                <el-date-picker v-model="dailyReportForm.createDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width:100%"> </el-date-picker>
            </el-form-item>
            <el-form-item label="仓库" prop="ckName">
                <el-select placeholder="请选择仓库" v-model="dailyReportForm.ckName" clearable>
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="getDailyReportList">搜索</el-button>
                <el-button type="primary" @click="inventoryCountExport">导出</el-button>
            </el-form-item>
        </el-form>
        <div style="flex:1;overflow: hidden" >
            <vxe-table id="dailyReportTable"  size="mini" ref="dailyReportTable" :data="dailyReportList" border stripe
            header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" height="auto">
                <!-- <vxe-column type="checkbox" fixed="left" width="50"></vxe-column> -->
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="createDate" title="入库日期" width="110" sortable ></vxe-column>
                <vxe-column field="blNo" title="提单号" sortable ></vxe-column>
                <vxe-column field="boxNo" title="箱号"  sortable ></vxe-column>
                <vxe-column field="goodsName" title="货物名称"   sortable ></vxe-column>
                <vxe-column field="spec" title="规格型号" sortable ></vxe-column>
                <vxe-column field="place" title="库区库位" width="130" sortable >
                    <template #default="{ row }">
                        {{row.place}} - {{row.location}}
                    </template>
                </vxe-column>
                <vxe-column field="netWeight" title="入库净重(吨)" width="130" sortable ></vxe-column>
                <vxe-column field="qty1" title="入库件数1" width="130" sortable ></vxe-column>
                <vxe-column field="outNetWeight" title="出库净重(吨)" width="130" sortable ></vxe-column>
                <vxe-column field="outQty1" title="出库件数1" width="130" sortable ></vxe-column>
                <vxe-column field="endNetWeight" title="结存净重(吨)" width="130" sortable ></vxe-column>
                <vxe-column field="endQty1" title="结存件数1" width="130" sortable ></vxe-column>
            </vxe-table>
        </div>
         
    </diV>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import clean from 'lodash-clean';
export default {
    name: 'wmsDailyReport',
    mixins: [userProfile],
    components:{

    },
    watch: { 
       
    },
    data() {
        return{
            dailyReportForm:{
                ckName:"",
                createDate:"",
            },
            dailyReportList:[],
            ckNameList:[], // 获取仓库列表
        }
    },
    async created() {
        await this.getckNameList()
        this.dailyReportForm.createDate = new Date().toISOString().split('T')[0] // 格式化为 "2026-02-03"
        await this.getDailyReportList()
    },
    mounted() {

    },
    methods: {
        // 获取数据
        getDailyReportList() { 
            return  this.$api.wmsGetCycleCount( this.dailyReportForm.ckName,this.dailyReportForm.createDate ).then(async res =>{
                this.dailyReportList = res
                // 查询详情
            })
        },
        // 获取仓库
        getckNameList(){
            return this.$api.getCkNamesBy(  ).then(res =>{
                console.log(res)
               this.ckNameList = res
               this.dailyReportForm.ckName = this.ckNameList[0]
            })
        },
        async inventoryCountExport(){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            
            const titleRow = worksheet.addRow([this.dailyReportForm.ckName + '库存盘点明细表']);
            worksheet.mergeCells('A1:M1');
            titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            titleRow.getCell(1).font = { bold: true, size: 16 };
            titleRow.height = 30;
            // 1. 添加信息行（手动添加，不使用列配置）
            const infoRow1 = worksheet.addRow([
                '盘点时间:' + this.dailyReportForm.createDate
            ]);
            worksheet.mergeCells('A2:M2');
            infoRow1.getCell(1).font = { bold: true, size: 12 };
            infoRow1.height = 20;

            const infoRow2 = worksheet.addRow([
                '备注:'
            ]);
            worksheet.mergeCells('A3:M3');
            infoRow2.getCell(1).font = { bold: true, size: 12 };
            infoRow2.height = 20;
            // 3. 手动添加表头行
            const headerRow1 = worksheet.addRow([
                '入库', '', '', '', '', '', '','', 
                '出库', '',
                '结存', '', 
                '',
            ]);
            // 合并一级表头
            worksheet.mergeCells('A4:H4');  // 基础信息
            worksheet.mergeCells('I4:J4');  // 库存位置
            worksheet.mergeCells('K4:L4');  // 数量信息
            headerRow1.getCell(1).font = { size: 12 };
            headerRow1.height = 20;

            const headerRow2 = worksheet.addRow([
                '入库日期', '提单号', '箱号', '货物名称', '规格型号','库区库位', '净重(吨)', '件数1',  // 入库
                '净重(吨)', '件数1',  // 出库
                '净重(吨)', '件数1',  // 结存
            ]);
    
            // 设置表头样式
            [headerRow1, headerRow2].forEach(row => {
                row.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        // fgColor: { argb: 'FFD3D3D3' }
                    };
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                });
                row.height = 24;
            });
            worksheet.mergeCells('M4:M5');
            worksheet.getCell('M4').value = '确认信息无误打√\n信息有误备注详细';
            worksheet.getCell('M4').alignment = { 
                horizontal: 'center', 
                vertical: 'middle', 
                wrapText: true 
            };
            var inventoryList = this.dailyReportList


             // ========== 全局边框样式（所有单元格统一边框，空单元格也生效） ==========
            const allBorder = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            // 【核心】数据行样式：左对齐 + 垂直居中 + 边框
            const dataRowStyle = {
                alignment: { vertical: 'middle', horizontal: 'left', wrapText: false },
                border: allBorder
            }
            // 4. 添加数据行
            inventoryList.forEach((item) => {
                const rowData = [
                    item.createDate,
                    item.blNo,
                    item.boxNo,
                    item.goodsName,
                    item.spec,
                    item.place + '-' + item.location,
                    item.netWeight,
                    item.qty1,
                    // item.qty1Unit ? this.findNameByCode(item.qty1Unit, this.unitList) : item.qty1UnitName,
                    item.outNetWeight,
                    item.outQty1,

                    item.endNetWeight,
                    item.endQty1,
                ];
        
                const dataRow = worksheet.addRow(rowData);
                dataRow.height = 20
                // 设置数据行的边框
                dataRow.eachCell(cell => cell.style = dataRowStyle)

            });
            // ===== 【修改3·核心】统一刷全表边框（标题行、信息行、空白单元格全部覆盖）=====
            const totalRows = worksheet.rowCount;
            const totalCols = 13; // A-M 共13列
            for (let r = 4; r <= totalRows; r++) {
                const row = worksheet.getRow(r);
                for (let c = 1; c <= totalCols; c++) {
                    const cell = row.getCell(c);
                    // 空单元格赋值为空文本，强制渲染边框
                    if (cell.value === undefined || cell.value === null) {
                        cell.value = '';
                    }
                    // 没有边框就补上（不覆盖已有特殊样式）
                    if (!cell.border) {
                        cell.border = allBorder;
                    }
                }
            }
            // 5. 设置列宽（在添加完所有行后设置）
            const columnWidths = [15, 20, 20, 26, 24, 15, 15, 15, 15, 15, 15, 15, 20];
            columnWidths.forEach((width, index) => {
                const col = worksheet.getColumn(index + 1);
                col.width = width;
            });
    
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.dailyReportForm.createDate}_日收发存盘点数据.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
    }
}
</script>